import { NextSeo } from 'next-seo';
import Breadcrumb from '@/components/breadcrumb';
import LayoutBase from '@/components/layout-base';
import contentLayoutBaseData from '@/content/content-layout-base-data';
import ContentSalesTeamPage from '@/content/content-sales-team-page';
import type { CmsArticleDetail } from '@/lib/cms-article-detail';
import cmsArticleDetail from '@/lib/cms-article-detail';
import type { CmsContactItem } from '@/lib/cms-contact-list';
import cmsContactList from '@/lib/cms-contact-list';
import i18nMessagesLoad from '@/lib/i18n-messages-load';
import { localizationContextFromGetStaticPropsContext } from '@/lib/localization-contenxt';
import revalidateAfter from '@/lib/revalidate-after';
import type { NextGetStaticProps, NextPageWithLayout } from './_app';

type SalesTeamPageProps = {
  article: CmsArticleDetail<string>;
  contactList: CmsContactItem[];
};

const SalesTeamPage: NextPageWithLayout<SalesTeamPageProps> = ({ article, contactList }) => {
  const { body: descriptionHtml, metaData, teaserText, title } = article;
  const metaTagKeyWords = metaData.keyWords ? [{ content: metaData.keyWords, property: 'keywords' }] : [];
  const pageTitle = title;

  return (
    <>
      <NextSeo
        additionalMetaTags={metaTagKeyWords}
        description={metaData.description || teaserText || ''}
        title={metaData.title || title}
      />

      <main className='content-container'>
        <Breadcrumb className='py-4'>
          <Breadcrumb.Item href={`/obchodni-tym`} isCurrenctPage={true} position={1}>
            {pageTitle}
          </Breadcrumb.Item>
        </Breadcrumb>

        <h1 className='heading-page'>{pageTitle}</h1>
        <ContentSalesTeamPage contactList={contactList} descriptionHtml={descriptionHtml} />
      </main>
    </>
  );
};

SalesTeamPage.displayName = 'SalesTeamPage';

SalesTeamPage.getLayout = (page) => {
  return <LayoutBase>{page}</LayoutBase>;
};

export default SalesTeamPage;

export const getStaticProps: NextGetStaticProps<SalesTeamPageProps> = async (getStaticPropsContext) => {
  const localizationContext = localizationContextFromGetStaticPropsContext(getStaticPropsContext);
  const intlMessages = await i18nMessagesLoad(localizationContext);
  const layoutData = await contentLayoutBaseData(localizationContext);
  const article = await cmsArticleDetail<string>(localizationContext, '/stranky', 'zakaznicky-servis');
  const contactList = await cmsContactList(localizationContext, '/stranky/zakaznicky-servis');
  if (article == null) return { notFound: true, revalidate: revalidateAfter('1m') };

  return {
    props: {
      article,
      contactList,
      intlMessages,
      layoutData,
    },
    revalidate: revalidateAfter('1h'),
  };
};
